const langPackLocalVersion = 37;export default langPackLocalVersion;
